<script setup lang="ts">
import { useToast } from '@/composables/useToast'
const { toasts, dismiss } = useToast()
</script>

<template>
  <div class="toasts">
    <div v-for="tst in toasts" :key="tst.id" class="toast" :class="tst.level" @click="dismiss(tst.id)">{{ tst.message }}</div>
  </div>
</template>

<style scoped>
.toasts {
  position: fixed;
  right: 16px;
  bottom: 34px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 200;
  pointer-events: none;
}
.toast {
  pointer-events: auto;
  background: var(--bg-2);
  border: 1px solid var(--line-strong);
  border-left: 3px solid var(--accent);
  border-radius: var(--radius);
  padding: 8px 12px;
  box-shadow: var(--shadow);
  max-width: 380px;
  cursor: pointer;
}
.toast.success {
  border-left-color: #4caf50;
}
.toast.warn {
  border-left-color: #e8a838;
}
.toast.error {
  border-left-color: var(--danger);
}
</style>
